import { render } from 'react-dom';
import { compose, createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { Provider } from 'react-redux';
import CruiseListContainer from './containers/CruiseListContainer';
import cruiseListApp from './redux/reducers/cruiseList';
import cruiseListQueryMiddleware from './redux/middleware/cruiseListQuery';

const initialState = window.__INITIAL_STATE_IW_CRUISE_LIST__;
delete window.__INITIAL_STATE_IW_CRUISE_LIST__;

const commonState = () => initialState;

const finalCreateStore = compose(
  applyMiddleware(thunkMiddleware, cruiseListQueryMiddleware),
)(createStore);

if (initialState) {
  const cruiseListStore = finalCreateStore(cruiseListApp(commonState));

  render(
    <Provider store={cruiseListStore}>
      <CruiseListContainer />
    </Provider>,
    document.getElementById('iw-cruise-list'),
  );
}
